module.exports = require("./fr-MF");